import {
  put,
  takeEvery,
  all,
  call,
  select,
  takeLatest,
} from "redux-saga/effects";
import {
  FETCH_DATA_TAG_DASHBOARD_DATA,
  SET_DATA_ESTATE,
  SET_DATA_TAG_FILE_CLASSIFICATIONS,
  SET_DATA_TAG_SENSITIVE_AND_REGULATED_DATA,
  SET_DATA_TAG_DUPLICATE_FILE_DATA,
  SET_DATA_TAG_METADATA,
  SET_DATA_TAG_LOADING,
  fetchDataEstateAPI,
  fetchDataTagFileClassificationsAPI,
  fetchDataTagSensitiveAndRegulatedDataAPI,
  fetchDataTagDuplicateFileDataAPI,
  fetchDataTagMetadataAPI,
  fetchTotalDataTagFilesAPI,
  SET_TOTAL_DATA_TAG_FILES,
  fetchDataTagAllFilesAPI,
  SET_DATA_TAG_ALL_FILES,
  FETCH_DATA_TAG_ALL_FILES,
  SET_ALL_DATA_TAG_SOURCES,
  FETCH_ALL_DATA_SOURCES_API_DATA_TAG,
  fetchDataTagUsersAPI,
  FETCH_DATA_TAG_USERS,
  SET_DATA_TAG_USERS,
  FETCH_DATA_ESTATE_SUMMARY,
  SET_DATA_ESTATE_SUMMARY,
  fetchDataEstateSummaryAPI,
  SET_DATA_TAG_DRIVES,
  fetchDataTagDrivesAPI,
  FETCH_DATA_TAG_DRIVES,
  fetchDataTagDataAccessibilityAPI,
  SET_DATA_TAG_ACCESSIBILITY,
  SEARCH_DATA_TAG_FILES,
  SET_SEARCHED_DATA_TAG_FILES,
  FETCH_DATA_TAG_FILES,
  SET_SEARCHED_DATA_TAG_USERS,
  FETCH_DATA_TAG_USERS_LIST,
  FETCH_SIZE_CARD_DATA,
  SET_SIZE_CARD_DATA,
  FETCH_SENSITIVE_SUMMARY_CARD_DATA,
  SET_SENSITIVE_SUMMARY_CARD_DATA,
  FETCH_CATEGORY_CARD_DATA,
  SET_CATEGORY_CARD_DATA,
  DATA_ESTATE_SUMMARY_LOADER,
  FETCH_ALL_FILE_TYPES_DATA,
  SET_ALL_FILE_TYPE_LIST,
  fetchAllFileTypes,
  DATA_TAG_DUPLICATE_DRIVE_DATA,
  fetchDataTagDuplicateDriveDataAPI,
  SET_DATA_TAG_DUPLICATE_DRIVE_DATA,
  fetchDataTagDuplicateUserDataAPI,
  SET_DATA_TAG_DUPLICATE_USER_DATA,
  DATA_TAG_DUPLICATE_USER_DATA,
  SET_DATA_TAG_DUPLICATE_USER_DATA_2,
  fetchDataTagDuplicateUserDataAPI_2,
  DATA_TAG_DUPLICATE_USER_DATA_2,
  fetchDataTagDuplicateDriveFileDataAPI,
  SET_DATA_TAG_DUPLICATE_DRIVE_FILE_DATA,
  DATA_TAG_DUPLICATE_FILE_DATA,
  SET_DATA_TAG_POPUP_LOADER,
  fetchDataTagDuplicateDriveFileDataAPI_2,
  SET_DATA_TAG_DUPLICATE_DRIVE_FILE_DATA_2,
  DATA_TAG_DUPLICATE_FILE_DATA_2,
  fileMapUrl,
  SET_FILE_MAP_DATA,
  GET_FILE_MAP_DATA,
  userFilterList,
  SET_USERS_LIST,
  FETCH_USERS_LIST,
  fileFilterList,
  SET_FILES_LIST,
  FETCH_FILES_LIST,
  SET_DATA_ESTATE_SUMMARY_TAB,
  DATA_ESTATE_SUMMARY_TAB_LOADER,
  fetchDataEstateSummaryTabAPI,
  FETCH_DATA_ESTATE_SUMMARY_TAB,
  dataEstateCoverageCardAPI,
  SET_DATA_ESTATE_COVERAGE_CARD,
  FETCH_DATA_ESTATE_COVERAGE_CARD,
  dataEstateOverviewAPI,
  FETCH_DATA_ESTATE_OVERVIEW,
  SET_DATA_ESTATE_OVERVIEW,
} from "./DataTagConstants";
import { getAxiosHeaders, getService } from "../../library/RestAPI";
import {
  cubejsApi,
  getCubejsApi,
  redirectToLogin,
} from "../../components/common/Dashboard/cubejs-util";
import {
  DATASOURCE_URL,
  SEARCH_DB_USER_URL,
} from "../../redux/constants/constants";

function* fetchData(apiUrl) {
  const options = {
    method: "GET",
    url: apiUrl,
    headers: getAxiosHeaders(true),
  };

  const response = yield call(getService, options);
  return response;
}

function* getDataTagDashboardDataSaga() {
  try {
    yield put({ type: SET_DATA_TAG_LOADING, payload: true });

    const [
      totalFilesRes,
      dataEstateRes,
      fileClassificationsRes,
      sensitiveRegulatedRes,
      duplicateFileRes,
      metadataRes,
      DataAccessibilityRes,
    ] = yield all([
      call(fetchData, fetchTotalDataTagFilesAPI),
      call(fetchData, fetchDataEstateAPI),
      call(fetchData, fetchDataTagFileClassificationsAPI),
      call(fetchData, fetchDataTagSensitiveAndRegulatedDataAPI),
      call(fetchData, fetchDataTagDuplicateFileDataAPI),
      call(fetchData, fetchDataTagMetadataAPI),
      call(fetchData, fetchDataTagDataAccessibilityAPI),
    ]);

    // Dispatch successful results
    if (totalFilesRes?.status === 200)
      yield put({
        type: SET_TOTAL_DATA_TAG_FILES,
        payload: totalFilesRes.data,
      });

    if (dataEstateRes?.status === 200)
      yield put({ type: SET_DATA_ESTATE, payload: dataEstateRes.data });

    if (fileClassificationsRes?.status === 200)
      yield put({
        type: SET_DATA_TAG_FILE_CLASSIFICATIONS,
        payload: fileClassificationsRes.data,
      });

    if (sensitiveRegulatedRes?.status === 200)
      yield put({
        type: SET_DATA_TAG_SENSITIVE_AND_REGULATED_DATA,
        payload: sensitiveRegulatedRes?.data,
      });

    if (duplicateFileRes?.status === 200)
      yield put({
        type: SET_DATA_TAG_DUPLICATE_FILE_DATA,
        payload: duplicateFileRes.data,
      });

    if (metadataRes?.status === 200)
      yield put({
        type: SET_DATA_TAG_METADATA,
        payload: metadataRes.data,
      });
    if (DataAccessibilityRes?.status === 200)
      yield put({
        type: SET_DATA_TAG_ACCESSIBILITY,
        payload: DataAccessibilityRes.data,
      });
  } catch (error) {
    console.error("Data Tag Dashboard Saga Error:", error);
    redirectToLogin(error);
  } finally {
    // Stop loader
    yield put({ type: SET_DATA_TAG_LOADING, payload: false });
  }
}

function* fetchDataTagAllFiles(action) {
  yield put({ type: SET_DATA_TAG_LOADING, payload: true });
  const {
    dataSourceId,
    page,
    size,
    fileNames,
    sensitivity,
    usernames,
    category,
    regulations,
    types,
    extensions,
  } = action.payload;

  let paramData = {};
  let sensitivityFilter = "";
  let fileNameFilter = "";
  let usernameFilter = "";
  let categoryFilter = "";
  let regulationsFilter = "";
  let typesFilter = "";
  let extensionFilter = "";

  if (regulations && regulations.length > 0) {
    regulationsFilter = regulations.join(",");
    paramData["regulations"] = regulationsFilter;
  }

  if (sensitivity && sensitivity.length > 0) {
    const mappedSensitivity = sensitivity.map((item) =>
      item === "NO_SENSITIVITY" ? "NOT_PROCESSED" : item,
    );

    sensitivityFilter = mappedSensitivity.join(",");
    paramData["sensitivity"] = sensitivityFilter;
  }
  if (fileNames && fileNames.length > 0) {
    fileNameFilter = fileNames.join(",");
    paramData["fileName"] = fileNameFilter;
  }
  if (usernames && usernames.length > 0) {
    usernameFilter = usernames.join(",");
    paramData["owner"] = usernameFilter;
  }
  if (category && category.length > 0) {
    categoryFilter = category.join(",");
    paramData["category"] = categoryFilter;
  }
  if (types && types.length > 0) {
    typesFilter = types.join(",");
    paramData["fileTypes"] = typesFilter;
  }
  if (extensions && extensions.length > 0) {
    extensionFilter = extensions.join(",");
    paramData["extensions"] = extensionFilter;
  }
  const options = {
    method: "GET",
    url: `${fetchDataTagAllFilesAPI(dataSourceId)}&page=${page}&size=${size}`,
    params: paramData,
    headers: getAxiosHeaders(true),
  };
  try {
    const response = yield call(getService, options);
    if (response?.status === 200) {
      yield put({
        type: SET_DATA_TAG_ALL_FILES,
        payload: {
          content: response.data?.content,
          totalCount: response.data?.totalElements,
        },
      });
      yield put({ type: SET_DATA_TAG_LOADING, payload: false });
    }
  } catch (error) {
    yield put({ type: SET_DATA_TAG_LOADING, payload: false });
    console.error("Error fetching all data tag files:", error);
    redirectToLogin(error);
  }
}

function* fetchAllDataSourcesAPIDataTag(action) {
  const { page, size } = action.payload;
  const options = {
    method: "GET",
    url: `${DATASOURCE_URL}?size=${size}&page=${page}`,
    headers: getAxiosHeaders(true),
    data: {},
  };
  try {
    const response = yield call(getService, options);
    if (response && response.status === 200) {
      yield put({
        type: SET_ALL_DATA_TAG_SOURCES,
        payload: response.data?.content.filter(
          (item) => item?.type?.code !== "ENTRA",
        ),
      });
    } else {
      console.error("Error Fetching Data.");
    }
  } catch (error) {
    console.error("Error fetching all data sources:", error);
  }
}

function* fetchDataTagUsers(action) {
  yield put({ type: SET_DATA_TAG_LOADING, payload: true });

  const { dataSourceId, page, size, usernames, sensitivity } = action.payload;

  let paramData = {};
  if (usernames?.length) {
    paramData["userName"] = usernames.join(",");
  }
  let sensitivityFilter = "";
  if (sensitivity && sensitivity.length > 0) {
    const mappedSensitivity = sensitivity.map((item) =>
      item === "NO_SENSITIVITY" ? "NOT_PROCESSED" : item,
    );

    sensitivityFilter = mappedSensitivity.join(",");
    paramData["category"] = sensitivityFilter;
  }

  const options = {
    method: "GET",
    url: `${fetchDataTagUsersAPI(dataSourceId)}&page=${page}&size=${size}`,
    params: paramData,
    headers: getAxiosHeaders(true),
  };

  try {
    const response = yield call(getService, options);

    if (response?.status === 200) {
      const transformed = response.data?.content?.map((item) => {
        const {
          criticalSensitivityFiles,
          highSensitivityFiles,
          mediumSensitivityFiles,
          lowSensitivityFiles,
          notProcessedFiles,
          noRiskFiles,
          noOfFiles,
          ...rest
        } = item;

        return {
          ...rest,
          noOfFiles,

          sensitivityData: {
            sensitivity_count_critical: criticalSensitivityFiles || 0,
            sensitivity_count_high: highSensitivityFiles || 0,
            sensitivity_count_medium: mediumSensitivityFiles || 0,
            sensitivity_count_low: lowSensitivityFiles || 0,
            sensitivity_count_no_risk: noRiskFiles || 0,
            sensitivity_count_not_processed: notProcessedFiles || 0,
            total_sensitivity_count: noOfFiles || 0,
          },
        };
      });

      yield put({
        type: SET_DATA_TAG_USERS,
        payload: {
          content: transformed,
          totalCount: response.data?.totalElements,
        },
      });

      yield put({ type: SET_DATA_TAG_LOADING, payload: false });
    }
  } catch (error) {
    yield put({ type: SET_DATA_TAG_LOADING, payload: false });
    console.error("Error fetching data tag users:", error);
    redirectToLogin(error);
  }
}

function* fetchDataEstateDrives(action) {
  yield put({ type: SET_DATA_TAG_LOADING, payload: true });
  const { dataSourceId, page, size, category, sensitivity } = action.payload;
  let paramData = {};
  let sensitivityFilter = "";
  let categoryFilter = "";
  if (sensitivity && sensitivity.length > 0) {
    const mappedSensitivity = sensitivity.map((item) =>
      item === "NO_SENSITIVITY" ? "NOT_PROCESSED" : item,
    );

    sensitivityFilter = mappedSensitivity.join(",");
    paramData["sensitivity"] = sensitivityFilter;
  }
  if (category && category.length > 0) {
    categoryFilter = category.join(",");
    paramData["fileType"] = categoryFilter;
  }
  const options = {
    method: "GET",
    url: `${fetchDataTagDrivesAPI(dataSourceId)}&page=${page}&size=${size}`,
    params: paramData,
    headers: getAxiosHeaders(true),
  };
  try {
    const response = yield call(getService, options);
    if (response?.status === 200) {
      yield put({
        type: SET_DATA_TAG_DRIVES,
        payload: response.data || [],
      });
      yield put({ type: SET_DATA_TAG_LOADING, payload: false });
    }
  } catch (error) {
    yield put({ type: SET_DATA_TAG_LOADING, payload: false });
    console.error("Error fetching data estate drives:", error);
    redirectToLogin(error);
  }
}

function* fetchDataEstateSummary(action) {
  yield put({ type: DATA_ESTATE_SUMMARY_LOADER, payload: true });
  const { dataSourceId } = action.payload;
  const options = {
    method: "GET",
    url: fetchDataEstateSummaryAPI(dataSourceId),
    headers: getAxiosHeaders(true),
  };
  try {
    const response = yield call(getService, options);
    if (response?.status === 200) {
      yield put({
        type: SET_DATA_ESTATE_SUMMARY,
        payload: response.data?.content[0],
      });
      yield put({ type: DATA_ESTATE_SUMMARY_LOADER, payload: false });
    }
  } catch (error) {
    yield put({ type: DATA_ESTATE_SUMMARY_LOADER, payload: false });
    console.error("Error fetching data estate summary:", error);
    redirectToLogin(error);
  }
}

function* searchDataTagFiles(action) {
  const { fileName, dataSourceId } = action.payload;
  const options = {
    method: "GET",
    url: SEARCH_DATA_TAG_FILES,
    headers: getAxiosHeaders(true),
    params: {
      query: fileName === "" ? " " : fileName,
      dataSourceId: dataSourceId,
    },
  };
  try {
    const response = yield call(getService, options);
    if (response?.status === 200) {
      yield put({
        type: SET_SEARCHED_DATA_TAG_FILES,
        payload: response.data?.content || [],
      });
    }
  } catch (error) {
    console.error("Error searching data tag files:", error);
    redirectToLogin(error);
  }
}

function* searchDataTagUsers(action) {
  const { userName, dataSourceId } = action.payload;
  const options = {
    method: "GET",
    url: SEARCH_DB_USER_URL,
    headers: getAxiosHeaders(true),
    params: {
      queryString: userName === "" ? " " : userName,
      // dataSourceId: dataSourceId
    },
  };
  try {
    const response = yield call(getService, options);
    if (response?.status === 200) {
      yield put({
        type: SET_SEARCHED_DATA_TAG_USERS,
        payload: response.data?.content || [],
      });
    }
  } catch (error) {
    console.error("Error searching data tag users:", error);
    redirectToLogin(error);
  }
}

function* fetchSizeCardData(action) {
  yield put({ type: DATA_ESTATE_SUMMARY_LOADER, payload: true });
  const dataSourceType = yield select(
    (state) => state.dataTagReducer.selectedDataSource?.type,
  );

  const isNTFS = dataSourceType === "NTFS";

  const processedCountMeasure = isNTFS
    ? "DataTagSensitivity.ntfsProcessedCount"
    : "DataTagSensitivity.processedCount";

  const isDataBase = yield select((state) => state.dataTagReducer.isDatabase);

  const cubejsApi = getCubejsApi();
  const dataSourceId = action.payload;

  // =========================================================
  // NON-DATABASE — single combined query for everything the
  // "size" card needs, including PDA. PDA-related figures now
  // come straight from DataTagSensitivity (publicAccessCheckedCount /
  // publicFilesCount / nonPublicFilesCount) instead of a separate
  // DataTagPDA query — one cube, one round trip.
  // =========================================================

  const sensitivityMeasuresQuery = {
    measures: [
      "DataTagSensitivity.count",
      "DataTagSensitivity.fileSizeTotal",
      "DataTagSensitivity.regulatedCount",
      processedCountMeasure,
      "DataTagSensitivity.notProcessedCount",
      "DataTagSensitivity.publicAccessCheckedCount",
      "DataTagSensitivity.publicFilesCount",
      "DataTagSensitivity.nonPublicFilesCount",
      "DataTagSensitivity.notScannedCount",
    ],
    filters: [
      {
        member: "DataTagSensitivity.dataSourceId",
        operator: "equals",
        values: [dataSourceId],
      },
    ],
  };

  const regulatedFileCountQuery = {
    measures: ["FileClassificationStats.fileCount"],
    filters: [
      {
        member: "FileClassificationStats.dataSourceId",
        operator: "equals",
        values: [dataSourceId],
      },
    ],
  };

  // =========================================================
  // DATABASE — totals/regulated/sensitive come from
  // DataguardDbViewTotal; "processed" is derived below from
  // DataguardDbSensitivity, since that cube doesn't expose a
  // direct processedColumns measure (only notProcessedColumns).
  // =========================================================

  const dbViewTotalQuery = {
    measures: [
      "DataguardDbViewTotal.totalColumns",
      "DataguardDbViewTotal.regulatedTables",
      "DataguardDbViewTotal.sensitiveColumns",
      "DataguardDbViewTotal.totalTables",
    ],
    filters: [
      {
        member: "DataguardDbViewTotal.dataSourceId",
        operator: "equals",
        values: [dataSourceId],
      },
    ],
  };

  const dbNotProcessedQuery = {
    measures: ["DataguardDbSensitivity.notProcessedColumns"],
    filters: [
      {
        member: "DataguardDbSensitivity.dataSourceId",
        operator: "equals",
        values: [dataSourceId],
      },
    ],
  };

  // OLD DATABASE PDA VALUES — untouched, same measure names as
  // before ("DO NOT REMOVE" per the existing component comment).
  // These represent Total Columns / non-PDA columns for the
  // database case specifically. Kept as a separate cube since this
  // consolidation only applies to the non-database branch.
  const dbPdaLegacyQuery = {
    measures: [
      "DataTagPDA.pdaProcessedCount",
      "DataTagPDA.nonPdaProcessedCount",
    ],
    filters: [
      {
        member: "DataTagPDA.dataSourceId",
        operator: "equals",
        values: [dataSourceId],
      },
    ],
  };

  try {
    const payload = {};

    if (isDataBase) {
      // ---------------------------------------------------------
      // DATABASE BRANCH — unchanged
      // ---------------------------------------------------------

      const [dbViewTotalRes, dbNotProcessedRes, dbPdaLegacyRes] = yield all([
        call([cubejsApi, cubejsApi.load], dbViewTotalQuery),
        call([cubejsApi, cubejsApi.load], dbNotProcessedQuery),
        call([cubejsApi, cubejsApi.load], dbPdaLegacyQuery),
      ]);

      const viewTotalRow = dbViewTotalRes.rawData();
      const notProcessedRow = dbNotProcessedRes.rawData();

      payload.totalColumns = viewTotalRow;
      payload.regulatedTables = viewTotalRow;
      payload.sensitiveColumns = viewTotalRow;
      payload.totalTables = viewTotalRow;

      // reshaped to the same key the component reads for both
      // branches (DataTagSensitivity.notProcessedCount), so
      // DataEstateSizeCard.jsx needs zero changes for either case
      payload.notProcessed = [
        {
          "DataTagSensitivity.notProcessedCount":
            notProcessedRow?.[0]?.[
              "DataguardDbSensitivity.notProcessedColumns"
            ] || "0",
        },
      ];

      const totalColumnsVal = Number(
        viewTotalRow?.[0]?.["DataguardDbViewTotal.totalColumns"] || 0,
      );
      const notProcessedVal = Number(
        notProcessedRow?.[0]?.["DataguardDbSensitivity.notProcessedColumns"] ||
          0,
      );

      payload.processed = [
        {
          "DataTagSensitivity.processedCount": String(
            Math.max(0, totalColumnsVal - notProcessedVal),
          ),
        },
      ];

      payload.pdaProcessed = dbPdaLegacyRes.rawData();
      payload.nonPdaProcessed = dbPdaLegacyRes.rawData();

      // not used in DB branch by the component, kept empty/safe
      payload.size = [];
      payload.total = [];
      payload.regulatedData = [];
      payload.sensitiveData = [];
    } else {
      // ---------------------------------------------------------
      // NON-DATABASE BRANCH — single query now, PDA folded into
      // DataTagSensitivity, no separate DataTagPDA call.
      // Regulated count now comes from FileClassificationStats,
      // fetched in parallel with the sensitivity measures query.
      // ---------------------------------------------------------

      const [sensitivityRes, regulatedFileCountRes] = yield all([
        call([cubejsApi, cubejsApi.load], sensitivityMeasuresQuery),
        call([cubejsApi, cubejsApi.load], regulatedFileCountQuery),
      ]);

      const sensitivityRow = sensitivityRes.rawData();
      if (isNTFS && sensitivityRow?.[0]) {
        sensitivityRow[0]["DataTagSensitivity.processedCount"] =
          sensitivityRow[0]["DataTagSensitivity.ntfsProcessedCount"];
      }

      // same single row, reused under every key the component reads —
      // this now includes the PDA-derived fields too
      payload.size = sensitivityRow;
      payload.total = sensitivityRow;
      payload.regulatedData = sensitivityRow;
      payload.sensitiveData = sensitivityRow;
      payload.processed = sensitivityRow;
      payload.notProcessed = sensitivityRow;

      // new: regulated count now comes from FileClassificationStats
      payload.regulatedFileCount = regulatedFileCountRes.rawData();

      // not used in file branch, kept empty/safe
      payload.totalColumns = [];
      payload.regulatedTables = [];
      payload.sensitiveColumns = [];
      payload.totalTables = [];
      payload.pdaProcessed = [];
      payload.nonPdaProcessed = [];
    }

    yield put({
      type: SET_SIZE_CARD_DATA,
      payload,
    });

    yield put({ type: DATA_ESTATE_SUMMARY_LOADER, payload: false });
  } catch (err) {
    yield put({ type: DATA_ESTATE_SUMMARY_LOADER, payload: false });
    console.error(err);
    redirectToLogin(err);
  }
}

function groupFileClassifications(data) {
  return Object.values(
    data.reduce((acc, row) => {
      const sensitivityId = row["FileClassificationStats.sensitivityId"];

      if (!acc[sensitivityId]) {
        acc[sensitivityId] = {
          sensitivityId,
          fileName: row["FileClassificationStats.fileName"],
          dataSourceId: row["FileClassificationStats.dataSourceId"],
          classifications: [],
        };
      }

      acc[sensitivityId].classifications.push(
        row["FileClassificationStats.classificationType"],
      );

      return acc;
    }, {}),
  );
}

function* fetchSensitiveCardData(action) {
  yield put({ type: DATA_ESTATE_SUMMARY_LOADER, payload: true });

  const isDataBase = yield select((state) => state.dataTagReducer.isDatabase);

  const cubejsApi = getCubejsApi();
  const dataSourceId = action.payload;

  // =========================================================
  // TOTAL
  // =========================================================

  const totalCount = {
    measures: ["DataTagSensitivity.count"],
    filters: [
      {
        member: "DataTagSensitivity.dataSourceId",
        operator: "equals",
        values: [dataSourceId],
      },
    ],
  };

  // =========================================================
  // DATA TAG SENSITIVITY
  // =========================================================

  const sensitiveData = {
    measures: ["DataTagSensitivity.count"],
    dimensions: ["DataTagSensitivity.category"],
    order: {
      "DataTagSensitivity.count": "desc",
    },
    filters: [
      {
        member: "DataTagSensitivity.dataSourceId",
        operator: "equals",
        values: [dataSourceId],
      },
    ],
  };

  // =========================================================
  // DATA TAG SENSITIVITY - ALL CARD MEASURES
  // =========================================================

  const sensitivityMeasuresData = {
    measures: [
      "DataTagSensitivity.count",
      "DataTagSensitivity.fileSizeTotal",
      "DataTagSensitivity.publicAccessCheckedCount",
      "DataTagSensitivity.regulatedCount",
      "DataTagSensitivity.notScannedCount",
      "DataTagSensitivity.publicFilesCount",
      "DataTagSensitivity.nonPublicFilesCount",
      "DataTagSensitivity.processedCount",
      "DataTagSensitivity.notProcessedCount",
    ],
    filters: [
      {
        member: "DataTagSensitivity.dataSourceId",
        operator: "equals",
        values: [dataSourceId],
      },
    ],
  };

  // =========================================================
  // DATA TAG PDA
  // =========================================================

  const pdaData = {
    measures: ["DataTagPDA.count", "DataTagPDA.publicAccessCheckedCount"],
    filters: [
      {
        member: "DataTagPDA.dataSourceId",
        operator: "equals",
        values: [dataSourceId],
      },
    ],
  };

  // =========================================================
  // FILE CLASSIFICATION
  // =========================================================

  const fileClassificationsStatus = {
    dimensions: ["FileClassificationStats.classificationCombination"],
    order: {
      "FileClassificationStats.fileCount": "desc",
    },
    measures: ["FileClassificationStats.fileCount"],
    filters: [
      {
        member: "FileClassificationStats.dataSourceId",
        operator: "equals",
        values: [dataSourceId],
      },
    ],
  };

  // =========================================================
  // DATABASE - REGULATION
  // =========================================================

  const dbFileClassificationsStatus = {
    measures: ["DataguardDbRegulation.fileCount"],
    dimensions: ["DataguardDbRegulation.classificationCombination"],
    order: {
      "DataguardDbRegulation.fileCount": "desc",
    },
    filters: [
      {
        member: "DataguardDbRegulation.dataSourceId",
        operator: "equals",
        values: [dataSourceId],
      },
    ],
  };

  // =========================================================
  // DATABASE - SENSITIVITY
  // =========================================================

  const dbSensitiveData = {
    measures: [
      "DataguardDbSensitivity.criticalColumns",
      "DataguardDbSensitivity.highColumns",
      "DataguardDbSensitivity.mediumColumns",
      "DataguardDbSensitivity.lowColumns",
      "DataguardDbSensitivity.notProcessedColumns",
      "DataguardDbSensitivity.criticalPercentage",
      "DataguardDbSensitivity.highPercentage",
      "DataguardDbSensitivity.mediumPercentage",
      "DataguardDbSensitivity.lowPercentage",
    ],
    filters: [
      {
        member: "DataguardDbSensitivity.dataSourceId",
        operator: "equals",
        values: [dataSourceId],
      },
    ],
  };

  try {
    // =========================================================
    // LOAD TOTAL
    // =========================================================

    const totalCountRes = yield cubejsApi.load(totalCount);

    // =========================================================
    // LOAD SENSITIVITY
    // =========================================================

    const sensitiveRes = yield cubejsApi.load(
      isDataBase ? dbSensitiveData : sensitiveData,
    );

    // =========================================================
    // LOAD FILE CLASSIFICATION
    // =========================================================

    const fileClassificationRes = yield cubejsApi.load(
      isDataBase ? dbFileClassificationsStatus : fileClassificationsStatus,
    );

    // =========================================================
    // LOAD ALL DATATAGSENSITIVITY MEASURES
    // =========================================================

    let sensitivityMeasuresResult = [];
    let sensitivityMeasures = {};

    if (!isDataBase) {
      const sensitivityMeasuresRes = yield cubejsApi.load(
        sensitivityMeasuresData,
      );

      sensitivityMeasuresResult = sensitivityMeasuresRes.rawData();

      // Cube returns one row because there is no dimension
      sensitivityMeasures = sensitivityMeasuresResult[0] || {};
    }

    // =========================================================
    // LOAD DATATAGPDA
    // =========================================================

    let pdaResult = [];
    let pdaMeasures = {};

    if (!isDataBase) {
      const pdaRes = yield cubejsApi.load(pdaData);

      pdaResult = pdaRes.rawData();

      // Cube returns one row because there is no dimension
      pdaMeasures = pdaResult[0] || {};
    }

    // =========================================================
    // SENSITIVITY DATA
    // =========================================================

    let sensitiveDataResult = sensitiveRes.rawData();

    if (isDataBase) {
      const row = sensitiveDataResult[0] || {};

      sensitiveDataResult = [
        {
          "DataTagSensitivity.category": "CRITICAL",
          "DataTagSensitivity.count":
            row["DataguardDbSensitivity.criticalColumns"] || "0",
        },
        {
          "DataTagSensitivity.category": "HIGH",
          "DataTagSensitivity.count":
            row["DataguardDbSensitivity.highColumns"] || "0",
        },
        {
          "DataTagSensitivity.category": "MEDIUM",
          "DataTagSensitivity.count":
            row["DataguardDbSensitivity.mediumColumns"] || "0",
        },
        {
          "DataTagSensitivity.category": "LOW",
          "DataTagSensitivity.count":
            row["DataguardDbSensitivity.lowColumns"] || "0",
        },
        {
          "DataTagSensitivity.category": "NOT_PROCESSED",
          "DataTagSensitivity.count":
            row["DataguardDbSensitivity.notProcessedColumns"] || "0",
        },
      ].sort(
        (a, b) =>
          Number(b["DataTagSensitivity.count"]) -
          Number(a["DataTagSensitivity.count"]),
      );
    }

    // =========================================================
    // FILE CLASSIFICATION DATA
    // =========================================================

    let fileClassificationData = fileClassificationRes.rawData();

    if (isDataBase) {
      fileClassificationData = fileClassificationData.map((item) => ({
        "FileClassificationStats.classificationCombination":
          item["DataguardDbRegulation.classificationCombination"],

        "FileClassificationStats.fileCount":
          item["DataguardDbRegulation.fileCount"],
      }));
    }

    const groupedFileClassifications = fileClassificationData;

    // =========================================================
    // EXTRACT DATATAGSENSITIVITY MEASURES
    // =========================================================

    const {
      ["DataTagSensitivity.count"]: count,
      ["DataTagSensitivity.fileSizeTotal"]: fileSizeTotal,
      ["DataTagSensitivity.publicAccessCheckedCount"]: publicAccessCheckedCount,
      ["DataTagSensitivity.regulatedCount"]: regulatedCount,
      ["DataTagSensitivity.notScannedCount"]: notScannedCount,
      ["DataTagSensitivity.publicFilesCount"]: publicFilesCount,
      ["DataTagSensitivity.nonPublicFilesCount"]: nonPublicFilesCount,
      ["DataTagSensitivity.processedCount"]: processedCount,
      ["DataTagSensitivity.notProcessedCount"]: notProcessedCount,
    } = sensitivityMeasures;

    // =========================================================
    // EXTRACT DATATAGPDA MEASURES
    // =========================================================

    const {
      ["DataTagPDA.count"]: pdaCount,
      ["DataTagPDA.publicAccessCheckedCount"]: pdaPublicAccessCheckedCount,
    } = pdaMeasures;

    // =========================================================
    // STORE DATA
    // =========================================================

    yield put({
      type: SET_SENSITIVE_SUMMARY_CARD_DATA,

      payload: {
        // =====================================================
        // Existing data
        // =====================================================

        sensitiveData: sensitiveDataResult,

        total: totalCountRes.rawData(),

        fileClassificationStatus: groupedFileClassifications,

        // =====================================================
        // DataTagSensitivity
        // =====================================================

        count: count || "0",

        fileSizeTotal: fileSizeTotal || "0",

        publicAccessCheckedCount: publicAccessCheckedCount || "0",

        regulatedCount: regulatedCount || "0",

        notScannedCount: notScannedCount || "0",

        publicFilesCount: publicFilesCount || "0",

        nonPublicFilesCount: nonPublicFilesCount || "0",

        processedCount: processedCount || "0",

        notProcessedCount: notProcessedCount || "0",

        // =====================================================
        // DataTagPDA
        // =====================================================

        pdaCount: pdaCount || "0",

        pdaPublicAccessCheckedCount: pdaPublicAccessCheckedCount || "0",

        // Keep raw responses too, if needed elsewhere
        sensitivityMeasures: sensitivityMeasuresResult,

        pda: pdaResult,
      },
    });

    // =========================================================
    // STOP LOADER
    // =========================================================

    yield put({
      type: DATA_ESTATE_SUMMARY_LOADER,
      payload: false,
    });
  } catch (err) {
    yield put({
      type: DATA_ESTATE_SUMMARY_LOADER,
      payload: false,
    });

    console.error(err);

    redirectToLogin(err);
  }
}

function* fetchCategories(action) {
  yield put({ type: DATA_ESTATE_SUMMARY_LOADER, payload: true });

  const isDataBase = yield select((state) => state.dataTagReducer.isDatabase);

  const cubejsApi = getCubejsApi();
  const dataSourceId = action.payload;

  const dbCategories = {
    measures: ["DataguardDbColumnCategory.columnCount"],
    dimensions: ["DataguardDbColumnCategory.columnCategory"],
    order: {
      "DataguardDbColumnCategory.columnCount": "desc",
    },
    filters: [
      {
        member: "DataguardDbColumnCategory.dataSourceId",
        operator: "equals",
        values: [dataSourceId],
      },
    ],
  };

  // NON-DATABASE / NTFS
  // Count unique field/file IDs from sensitivity_model_info,
  // using sensitivity_info only to identify the data source.
  const categories = {
    filters: [
      {
        member: "DataTagSensitivityTypeCount.dataSourceId",
        operator: "equals",
        values: [dataSourceId],
      },
    ],
    dimensions: ["DataTagSensitivityTypeCount.type"],
    order: {
      "DataTagSensitivityTypeCount.typeCount": "desc",
    },
    measures: ["DataTagSensitivityTypeCount.typeCount"],
  };

  try {
    const resultSet = yield cubejsApi.load(
      isDataBase ? dbCategories : categories,
    );

    let result = resultSet.rawData();

    if (isDataBase) {
      result = result.map((item) => ({
        "DataTagSensitivity.finalType":
          item["DataguardDbColumnCategory.columnCategory"],
        "DataTagSensitivity.count":
          item["DataguardDbColumnCategory.columnCount"],
      }));
    } else {
      // Keep the same response shape expected by the existing component.
      result = result.map((item) => ({
        "DataTagSensitivity.finalType":
          item["DataTagSensitivityTypeCount.type"],
        "DataTagSensitivity.count":
          item["DataTagSensitivityTypeCount.typeCount"],
      }));
    }

    yield put({
      type: SET_CATEGORY_CARD_DATA,
      payload: result,
    });

    yield put({
      type: DATA_ESTATE_SUMMARY_LOADER,
      payload: false,
    });
  } catch (error) {
    console.log(error);
    yield put({
      type: DATA_ESTATE_SUMMARY_LOADER,
      payload: false,
    });
    redirectToLogin(error);
  }
}

function* fetchAllFileTypesData(action) {
  const dataSourceId = action.payload;
  const options = {
    method: "GET",
    url: fetchAllFileTypes(dataSourceId),
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield call(getService, options);
    if (res?.status === 200) {
      yield put({
        type: SET_ALL_FILE_TYPE_LIST,
        payload: res?.data || [],
      });
    }
  } catch (err) {
    console.log(err);
    redirectToLogin(err);
  }
}

function* fetchDuplicateDriveSummary(action) {
  // yield put({ type: SET_DATA_TAG_LOADING, payload: true });
  const { dataSourceId, page, size } = action.payload;
  const options = {
    method: "GET",
    url: fetchDataTagDuplicateDriveDataAPI(dataSourceId, page, size),
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield call(getService, options);
    if (res?.status === 200) {
      yield put({
        type: SET_DATA_TAG_DUPLICATE_DRIVE_DATA,
        payload: res?.data?.content || [],
      });
      // yield put({ type: SET_DATA_TAG_LOADING, payload: false });
    }
  } catch (err) {
    console.log(err);
    // yield put({ type: SET_DATA_TAG_LOADING, payload: false });
    redirectToLogin(err);
  }
}

function* fetchDuplicateUserData(action) {
  yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: true });
  const { dataSourceId, actorId, page, size, usernameFilter } = action.payload;
  console.log(usernameFilter, "fhjfh");
  let paramData = {};
  if (usernameFilter?.length) {
    paramData["duplicateActorId"] = usernameFilter
      .map((user) => user.id)
      .join(",");
  }
  const options = {
    method: "GET",
    url: fetchDataTagDuplicateUserDataAPI(dataSourceId, actorId, page, size),
    params: paramData,
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield call(getService, options);
    if (res?.status === 200) {
      yield put({
        type: SET_DATA_TAG_DUPLICATE_USER_DATA,
        payload: res?.data || [],
      });
      yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    }
  } catch (err) {
    console.log(err);
    yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    redirectToLogin(err);
  }
}

function* fetchDuplicateUserData_2(action) {
  yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: true });
  const { dataSourceId, actorId, page, size, duplicateActorId, directory } =
    action.payload;
  const options = {
    method: "GET",
    url: fetchDataTagDuplicateUserDataAPI_2(
      dataSourceId,
      actorId,
      duplicateActorId,
      directory,
      page,
      size,
    ),
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield call(getService, options);
    if (res?.status === 200) {
      yield put({
        type: SET_DATA_TAG_DUPLICATE_USER_DATA_2,
        payload: res?.data || [],
      });
      yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    }
  } catch (err) {
    console.log(err);
    yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    redirectToLogin(err);
  }
}

function* fetchDuplicateDriveFileData(action) {
  yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: true });
  const { dataSourceId, actorId, page, size, sensitivity, fileNames } =
    action.payload;
  let paramData = {};
  let sensitivityFilter = "";
  let fileFilter = "";
  if (sensitivity && sensitivity.length > 0) {
    const mappedSensitivity = sensitivity.map((item) =>
      item === "NO_SENSITIVITY" ? "NOT_PROCESSED" : item,
    );

    sensitivityFilter = mappedSensitivity.join(",");
    paramData["sensitivities"] = sensitivityFilter;
  }
  if (fileNames && fileNames.length > 0) {
    fileFilter = fileNames.join(",");
    paramData["fileNames"] = fileFilter;
  }
  const options = {
    method: "GET",
    url: fetchDataTagDuplicateDriveFileDataAPI(
      dataSourceId,
      actorId,
      page,
      size,
    ),
    params: paramData,
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield call(getService, options);
    if (res?.status === 200) {
      yield put({
        type: SET_DATA_TAG_DUPLICATE_DRIVE_FILE_DATA,
        payload: res?.data || [],
      });
      yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    }
  } catch (err) {
    console.log(err);
    yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    redirectToLogin(err);
  }
}

function* fetchFileMapData(action) {
  yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: true });
  const { dataSourceId, actorId } = action.payload;
  const options = {
    method: "GET",
    url: fileMapUrl(actorId, dataSourceId),
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield call(getService, options);
    if (res?.status === 200) {
      yield put({
        type: SET_FILE_MAP_DATA,
        payload: res?.data || [],
      });
      yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    }
  } catch (err) {
    console.log(err);
    yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    redirectToLogin(err);
  }
}

function* fetchDuplicateDriveFileData2(action) {
  yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: true });
  const { dataSourceId, fileId, page, size } = action.payload;
  const options = {
    method: "GET",
    url: fetchDataTagDuplicateDriveFileDataAPI_2(
      dataSourceId,
      fileId,
      page,
      size,
    ),
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield call(getService, options);
    if (res?.status === 200) {
      yield put({
        type: SET_DATA_TAG_DUPLICATE_DRIVE_FILE_DATA_2,
        payload: res?.data || [],
      });
      yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    }
  } catch (err) {
    console.log(err);
    yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    redirectToLogin(err);
  }
}

function* getUsersList(action) {
  yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: true });
  const { dataSourceId, actorId } = action.payload;
  const options = {
    method: "GET",
    url: userFilterList(dataSourceId, actorId),
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield call(getService, options);
    if (res?.status === 200) {
      yield put({
        type: SET_USERS_LIST,
        payload: res?.data || [],
      });
      yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    }
  } catch (err) {
    console.log(err);
    yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    redirectToLogin(err);
  }
}

function* fetchFileList(action) {
  yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: true });
  const { dataSourceId, actorId } = action.payload;
  const options = {
    method: "GET",
    url: fileFilterList(dataSourceId, actorId),
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield call(getService, options);
    if (res?.status === 200) {
      yield put({
        type: SET_FILES_LIST,
        payload: res?.data || [],
      });
      yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    }
  } catch (err) {
    console.log(err);
    yield put({ type: SET_DATA_TAG_POPUP_LOADER, payload: false });
    redirectToLogin(err);
  }
}

//Data Estate Summary Tab
function* fetchDataEstateSummaryTab(action) {
  yield put({ type: SET_DATA_TAG_LOADING, payload: true });
  const options = {
    method: "GET",
    url: fetchDataEstateSummaryTabAPI(),
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield call(getService, options);
    if (res?.status === 200) {
      yield put({
        type: SET_DATA_ESTATE_SUMMARY_TAB,
        payload: res?.data || [],
      });
      yield put({ type: SET_DATA_TAG_LOADING, payload: false });
    }
  } catch (err) {
    console.log(err);
    yield put({ type: SET_DATA_TAG_LOADING, payload: false });
    redirectToLogin(err);
  }
}

//Data Estate Coverage Card
function* fetchDataEstateCoverageCard(action) {
  yield put({ type: SET_DATA_TAG_LOADING, payload: true });
  const options = {
    method: "GET",
    url: dataEstateCoverageCardAPI(),
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield call(getService, options);
    if (res?.status === 200) {
      yield put({
        type: SET_DATA_ESTATE_COVERAGE_CARD,
        payload: res?.data || [],
      });
      yield put({ type: SET_DATA_TAG_LOADING, payload: false });
    }
  } catch (err) {
    console.log(err);
    yield put({ type: SET_DATA_TAG_LOADING, payload: false });
    redirectToLogin(err);
  }
}

// Data Estate Overview: ONE call that feeds the Regulated, Sensitivity, Category
// and Data Accessibility Index cards for the selected data source.
function* fetchDataEstateOverview(action) {
  const dataSourceId = action.payload;
  if (!dataSourceId) return;

  // clear the previous data source's numbers while the new ones load
  yield put({ type: SET_DATA_ESTATE_OVERVIEW, payload: {} });
  yield put({ type: SET_CATEGORY_CARD_DATA, payload: [] });
  yield put({ type: DATA_ESTATE_SUMMARY_LOADER, payload: true });

  const options = {
    method: "GET",
    url: dataEstateOverviewAPI(dataSourceId),
    headers: getAxiosHeaders(true),
  };
  try {
    const res = yield call(getService, options);
    if (res?.status === 200) {
      const overview = res?.data || {};
      yield put({ type: SET_DATA_ESTATE_OVERVIEW, payload: overview });

      // ---------------------------------------------------------------
      // Keep the shapes the Data Tag table filters still read, so the
      // Regulated / Category / Sensitivity quick filters keep working:
      //   sensitiveCardData.fileClassificationStatus -> Regulated filter
      //   categoryCardData                            -> Category filter
      // ---------------------------------------------------------------
      const KNOWN_CATEGORIES = [
        "PERSONAL",
        "MARKETING",
        "FINANCIAL",
        "ORGANIZATIONAL",
        "MEDICAL",
        "API",
        "NO_SENSITIVITY",
        "OTHER",
        "NOT_PROCESSED",
      ];

      const categoryRows = (overview?.card4?.classifications || [])
        .filter((c) => KNOWN_CATEGORIES.includes(c.label))
        .map((c) => ({
          "DataTagSensitivity.finalType": c.label,
          "DataTagSensitivity.count": Number(c.count) || 0,
        }));
      yield put({ type: SET_CATEGORY_CARD_DATA, payload: categoryRows });

      const prevSensitive = yield select(
        (state) => state.dataTagReducer.sensitiveCardData,
      );
      yield put({
        type: SET_SENSITIVE_SUMMARY_CARD_DATA,
        payload: {
          ...prevSensitive,
          sensitiveData: (overview?.card3?.severity || []).map((s) => ({
            "DataTagSensitivity.category": s.label,
            "DataTagSensitivity.count": Number(s.count) || 0,
          })),
          fileClassificationStatus: (overview?.card3?.regulations || []).map(
            (r) => ({
              "FileClassificationStats.classificationCombination": r.label,
              "FileClassificationStats.fileCount": Number(r.count) || 0,
            }),
          ),
          total: [
            { "DataTagSensitivity.count": Number(overview?.card2?.totalFiles) || 0 },
          ],
        },
      });
    }
  } catch (err) {
    console.log(err);
    redirectToLogin(err);
  } finally {
    yield put({ type: DATA_ESTATE_SUMMARY_LOADER, payload: false });
  }
}

/**
 * Watcher Saga
 */
function* DataTagDashboardSaga() {
  yield takeEvery(FETCH_DATA_TAG_DASHBOARD_DATA, getDataTagDashboardDataSaga);
  yield takeEvery(FETCH_DATA_TAG_ALL_FILES, fetchDataTagAllFiles);
  yield takeEvery(
    FETCH_ALL_DATA_SOURCES_API_DATA_TAG,
    fetchAllDataSourcesAPIDataTag,
  );
  yield takeEvery(FETCH_DATA_TAG_USERS, fetchDataTagUsers);
  yield takeEvery(FETCH_DATA_TAG_DRIVES, fetchDataEstateDrives);
  yield takeEvery(FETCH_DATA_ESTATE_SUMMARY, fetchDataEstateSummary);
  yield takeEvery(FETCH_DATA_TAG_FILES, searchDataTagFiles);
  yield takeEvery(FETCH_DATA_TAG_USERS_LIST, searchDataTagUsers);
  yield takeEvery(FETCH_SIZE_CARD_DATA, fetchSizeCardData);
  yield takeEvery(FETCH_SENSITIVE_SUMMARY_CARD_DATA, fetchSensitiveCardData);
  yield takeEvery(FETCH_CATEGORY_CARD_DATA, fetchCategories);
  yield takeEvery(FETCH_ALL_FILE_TYPES_DATA, fetchAllFileTypesData);
  yield takeEvery(DATA_TAG_DUPLICATE_DRIVE_DATA, fetchDuplicateDriveSummary);
  yield takeEvery(DATA_TAG_DUPLICATE_USER_DATA, fetchDuplicateUserData);
  yield takeEvery(DATA_TAG_DUPLICATE_USER_DATA_2, fetchDuplicateUserData_2);
  yield takeEvery(DATA_TAG_DUPLICATE_FILE_DATA, fetchDuplicateDriveFileData);
  yield takeEvery(DATA_TAG_DUPLICATE_FILE_DATA_2, fetchDuplicateDriveFileData2);
  yield takeEvery(GET_FILE_MAP_DATA, fetchFileMapData);
  yield takeEvery(FETCH_USERS_LIST, getUsersList);
  yield takeEvery(FETCH_FILES_LIST, fetchFileList);
  yield takeLatest(FETCH_DATA_ESTATE_SUMMARY_TAB, fetchDataEstateSummaryTab);
  yield takeLatest(
    FETCH_DATA_ESTATE_COVERAGE_CARD,
    fetchDataEstateCoverageCard,
  );
  yield takeLatest(FETCH_DATA_ESTATE_OVERVIEW, fetchDataEstateOverview);
}

export default DataTagDashboardSaga;